import BaseApi from '@/api/BaseApi';
import type { IPaginate } from '@/models/TableSettingsModel';
import type { IArticleResponse, ICreateEditArticleRequest } from '@/models/ArticleModel';

export default class ArticleApi extends BaseApi {
	async deleteArticle (articleId: number, isAdmin: boolean) {
		return this.delete({
			url: `/api${isAdmin ? '/admin/articles' : '/articles'}/${articleId}`,
		});
	};

	async createArticle (payload: ICreateEditArticleRequest, isAdmin: boolean) {
        const data = new FormData();
        data.append('title', payload.title);
        if (null != payload.excerpt) {
            data.append('excerpt', payload.excerpt);
        }
        data.append('image', payload.image);
        data.append('content', payload.content);
        if (null != payload.product_id) {
            data.append('product_id', payload.product_id);
        }
        data.append('product_id', payload.product_id);
		return this.post<ICreateEditArticleRequest, any>({
			url: `/api${isAdmin ? '/admin/articles' : '/articles'}`,
            data,
            config: {
                contentType: 'multipart/form-data',
            },
		});
	};

	async editArticle (payload: ICreateEditArticleRequest, articleId: string | string[], isAdmin: boolean) {
        const data = new FormData();
        data.append('id', payload.id);
        data.append('title', payload.title);
        if (null != payload.excerpt) {
            data.append('excerpt', payload.excerpt);
        }
        data.append('image', payload.image);
        data.append('content', payload.content);
        if (null != payload.product_id) {
            data.append('product_id', payload.product_id);
        }
		return this.post<ICreateEditArticleRequest, any>({
			url: `/api${isAdmin ? '/admin/articles' : '/articles'}/${articleId}`,
            data,
            config: {
                contentType: 'multipart/form-data',
            },
		});
	};

	async articleDetails (articleId: string | string[], isAdmin: boolean) {
		return this.get<IArticleResponse>({
			url: `/api${isAdmin ? '/admin/articles' : '/articles'}/${articleId}`,
		});
	};

    async articleList (page: number, perPage: number, sortBy: string | null, sortDesc: string | null, isAdmin: boolean, search: string | null) {
        let url = `/api${isAdmin ? '/admin/articles' : '/articles'}?page=${page}&per_page=${perPage}`;

        if (null != sortBy) {
            url += `&sort=${sortBy}`;
        }

        if (null != sortDesc) {
            url += `&order=${sortDesc}`;
        }

        if (null != search) {
            url += `&search=${search}`;
        }

        return this.get<IPaginate<IArticleResponse>>({
            url: url,
        });
    };
};
